(function () {
    "use strict";

    angular.module('iMatApp')
        .controller('ModelViewerController', ModelViewerController);

    ModelViewerController.$inject = ['$scope', '$timeout', '_', 'modelViewerService', 'modelTabWorkflow', 'mainWorkspace', "eventService", "upload3DModelTrackEventsService"];

    function ModelViewerController($scope, $timeout, _, modelViewerService, workflow, mainWorkspace, eventService, upload3DModelTrackEventsService) {
        var vm = this;
        var lazyHighlightMessage = _.debounce(highlightMessage, 300, true);

        vm.isClosedFailedFixedPreview = false;
        vm.isClosedGeneratingFixedPreview = false;
        vm.isHighlightedGeneratingPreviewForFixedModelMessage = false;

        vm.getPreviewInfo = getPreviewInfo;
        vm.getFileToShowDirectly = getFileToShowDirectly;
        vm.getRenderingData = getRenderingData;
        vm.getOptions = getOptions;
        vm.isGeneratingPreviewForFixedModel = isGeneratingPreviewForFixedModel;
        vm.isGeneratingPreviewFailedForFixedModel = isGeneratingPreviewFailedForFixedModel;

        vm.modelViewerFailed = workflow.modelRenderingFailed;
        vm.isClippingEnabled = modelViewerService.clippingEnabled;
        vm.clippingAxis = modelViewerService.clippingAxis;
        vm.clippingAmount = modelViewerService.clippingAmount;
        vm.clippingFlipDirection = modelViewerService.clippingFlipDirection;

        eventService.subscribe($scope, 'viewerToggleAutoRotate', viewerToggleAutoRotate);
        eventService.subscribe($scope, 'HighlightMessage_GeneretingPreviewForFixedModel', highlightGeneretingPreviewForFixedModelMeesage);

        // --------------------------------------------------------------------------------------

        function getPreviewInfo() {
            return mainWorkspace.product.model.previewInfo;
        }

        function getFileToShowDirectly() {
            return mainWorkspace.fileToShowDirectly;
        }

        function getRenderingData() {
            var colour = mainWorkspace.product.colour();
            return colour ? colour.renderingData : null;
        }

        function getOptions() {
            return mainWorkspace.options.viewer;
        }

        function isGeneratingPreviewForFixedModel() {
            var model = mainWorkspace.product.model;

            return mainWorkspace.fileToShowDirectly
                && model.hasBeenFixed
                && model.isPreviewGenerating;
        }

        function isGeneratingPreviewFailedForFixedModel() {
            var model = mainWorkspace.product.model;

            return mainWorkspace.fileToShowDirectly
                && model.hasBeenFixed
                && model.isPreviewGeneratingFailed;
        }

        function viewerToggleAutoRotate() {
            upload3DModelTrackEventsService.trackViewerToggleAutoRotate(modelViewerService.autoRotateEnabled());
        }

        function highlightGeneretingPreviewForFixedModelMeesage() {

            vm.isClosedFailedFixedPreview = false;
            vm.isClosedGeneratingFixedPreview = false;

            lazyHighlightMessage();
        }

        function highlightMessage() {
            $scope.$apply(function () {
                vm.isHighlightedGeneratingPreviewForFixedModelMessage = true;
                $timeout(function () {
                    vm.isHighlightedGeneratingPreviewForFixedModelMessage = false;
                }, 1000);
            });
        }
    }
})();